import React, { useState } from 'react';
import { Map } from '../map/Map';
import * as styles from './mapWrapper.module.scss';
import Localication from '../../../../static/localisation.svg';
import Plus from '../../../../static/plus.svg';
import Minus from '../../../../static/minus.svg';

interface IMapWrapperProps {
  lat: number;
  lng: number;
}

export const MapWrapper = ({ lat, lng }: IMapWrapperProps) => {
  const [zoom, setZoom] = useState<number>(11);
  const [center, setCenter] = useState([lat, lng]);

  return (
    <div className={styles.wrapper}>
      <Map lat={lat} lng={lng} zoom={zoom} center={center} setCenter={setCenter} />
      <div className={styles.customBtnsWrapper}>
        <div className={styles.customBtns}>
          <Localication onClick={() => setCenter([lat, lng])} />
          <Plus onClick={() => setZoom(zoom + 1)} />
          <Minus onClick={() => setZoom(zoom - 1)} />
        </div>
      </div>
    </div>
  );
};
